export default {
    visaExchangeCalculatorAmountInput: {
        dataTrackId: 'visa-exchange-calculator-amount-input',
        dataTrackLinkname: 'valutakalkulator - belopsfelt',
    },
    visaExchangeCalculatorReadMoreCardInfoIconButton: {
        dataTrackId: 'visa-exchange-calculator-read-more-card-info-icon-button',
        dataTrackLinkname: 'valutakalkulator - infoikon knapp',
    },
    visaExchangeCalculatorSelectCurrency: {
        dataTrackId: 'visa-exchange-calculator-select-currency',
        dataTrackLinkname: 'endre valuta',
    },
    visaExchangeCalculatorReadMoreCardButton: {
        dataTrackId: 'visa-exchange-calculator-read-more-card-button',
        dataTrackLinkname: 'valutakalkulator - les mer-knapp i infokort',
    },
    visaExchangeCalculatorSelectCurrencyOption: {
        dataTrackId: 'visa-exchange-calculator-select-currency-option',
        dataTrackLinkname: 'valutaalternativ',
    },
    visaExchangeCalculatorSelectCurrencySearch: {
        dataTrackId: 'visa-exchange-calculator-select-currency-search',
        dataTrackLinkname: 'sok etter valuta',
    },
    visaExchangeCalculatorSwapCurrencies: {
        dataTrackId: 'visa-exchange-calculator-swap-currencies',
        dataTrackLinkname: 'bytt retning valuta',
    },
};
